import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CryptoJS from 'crypto-js';
import { colorBorder, colorBackground, colorHover } from '@/utils/palette';
import { left } from '@/utils/directions';
import { GiMeal } from 'react-icons/gi';
import SidebarLink, { SidebarNavLink, SidebarLinkTitle } from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { AuthContext } from '../../../../context/AuthContext';
import { PermissionContext } from '../../../../context/PermissionContext';


const SidebarContent = ({
  onClick, changeToLight, changeToDark, collapse,
}) => {
  const {
 userid, setUserId, apiGlobal, statusCode, setStatusCode, restaurantid, 
 setRestaurantId, type, setType,
} = useContext(AuthContext);


  const { setPermissionsAccess, permissionsAccess, permissionUpdate } = useContext(PermissionContext);
  

  // const fetchPermissions = async () => {
  //   try {
  //     const response = await fetch(`${apiGlobal}/restaurant/restaurant_permission.php?id=${userid}`);
  //     const data = await response.json();

  //     console.log('Fetched Permissions:', data);

  //     if (data.status && data.message === 'Success') {
  //       setPermissionsAccess(data.data[0].permission);
  //     } else {
  //       setPermissionsAccess([]);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching permissions:', error);
  //     setPermissionsAccess([]);
  //   }
  // };

  // useEffect(() => {
  //   if (userid) {
  //     fetchPermissions();
  //   }
  // }, [userid, permissionUpdate]);


  // useEffect(() => {
  //   // Decrypt and retrieve the user ID from localStorage only once when the component mounts
  //   const encryptedData = localStorage.getItem('resuserid');
  //   const encryptedStatusCode = localStorage.getItem('resstatuscode');
  //   const encryptedResID = localStorage.getItem('restauresID');
  //   const encryptedType = localStorage.getItem('restype');
  //   if (encryptedData && encryptedStatusCode && encryptedResID && encryptedType) {
  //     const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //     const bytes1 = CryptoJS.AES.decrypt(encryptedStatusCode, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //     const bytes2 = CryptoJS.AES.decrypt(encryptedResID, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //     const bytes3 = CryptoJS.AES.decrypt(encryptedType, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //     const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
  //     const decryptedStatusCode = bytes1.toString(CryptoJS.enc.Utf8);
  //     const decryptedResID = bytes2.toString(CryptoJS.enc.Utf8);
  //     const decryptedType = bytes3.toString(CryptoJS.enc.Utf8);
  //     setUserId(decryptedUserId);
  //     setStatusCode(decryptedStatusCode);
  //     setRestaurantId(decryptedResID);
  //     setType(decryptedType);
  //   }
  // }, [statusCode, userid, restaurantid, type]); // Empty dependency array ensures this runs only once
  
  return (
    <div>
      <SidebarContentWrap collapse={collapse}>
        <SidebarBlock collapse={collapse}>
          <SidebarLink
            title="App Dashboard"
            icon="smartphone"
            route="/app_dashboard"
            onClick={onClick}
          />
        
        </SidebarBlock>
        {statusCode === '1' && (
        <SidebarBlock collapse={collapse}>
          {permissionsAccess?.[0]?.master_id === '1'
        && permissionsAccess?.[0]?.view === 1 && (
          <SidebarLink title="Restaurant" icon="apartment" route="/restaurant/restaurant" onClick={onClick} />
        )}
          {permissionsAccess?.[1]?.master_id === '2'
        && permissionsAccess?.[1]?.view === 1 && (
          <SidebarCategory title="Meal" icon="dinner" collapse={collapse}>
            {/* <SidebarLink title="Meal" icon="dinner" route="/restaurant/meal" onClick={onClick} /> */}
            <SidebarLink 
              title="Search" 
              icon="magnifier" 
              color="green" 
              route="/restaurant/meal"
              onClick={onClick}
            />
            <SidebarLink 
              title="Request" 
              color="orange"
              icon="users"
              route="/restaurant/request"
              onClick={onClick}
            />
            <SidebarLink 
              title="Rejected Request" 
              color="red"
              icon="warning"
              route="/restaurant/resRejectedRequest"
              onClick={onClick}
            />
            {/* <SidebarLink title="Meal" icon="dinner" route="/restaurant/request" onClick={onClick} /> */}
          </SidebarCategory>
 )} 

          {/* {permissionsAccess?.[1]?.master_id === '2'
        && permissionsAccess?.[1]?.view === 1 && (
          <SidebarLink title="Meal" icon="dinner" route="/restaurant/meal" onClick={onClick} />
        )}  */}
          {permissionsAccess?.[2]?.master_id === '3'
        && permissionsAccess?.[2]?.view === 1 && (
          <SidebarLink title="Booking" icon="list" route="/restaurant/booking" onClick={onClick} />
        )} 


          {permissionsAccess?.[3]?.master_id === '4'
          && permissionsAccess?.[3]?.view === 1 && (
            <SidebarCategory title="Restaurant Account" icon="chart-bars" collapse={collapse}>
              <SidebarLink
                title="Account"
                icon="book"
                route="/restaurant/account"
                onClick={onClick}
                color="purple"
              />
              <SidebarLink
                title="Approved"
                icon="checkmark-circle"
                route="/restaurant/accountapproved"
                onClick={onClick}
                color="green"
              />
              <SidebarLink
                title="Request"
                color="orange"
                icon="users"
                route="/restaurant/accountrequest"
                onClick={onClick}
              />
              <SidebarLink
                title="Rejected Request"
                color="red"
                icon="warning"
                route="/restaurant/accountrejectrequest"
                onClick={onClick}
              />
            </SidebarCategory>
          )}
         
          

          {type === '0' && (
          <SidebarCategory title="User Manager" icon="user" collapse={collapse} po>
            <SidebarLink title="Users" icon="users" route="/usermanager/users" onClick={onClick} />
            <SidebarLink title="Users Management" icon="database" route="/usermanger/management" onClick={onClick} />
          </SidebarCategory>
        )}
        </SidebarBlock>
      )}
        {/* <SidebarLink title="Users" icon="users" route="/usermanager/users" onClick={onClick} /> */}
      </SidebarContentWrap>
      
    </div>
    
  );
};

SidebarContent.propTypes = {
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  collapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
  collapse: false,
  onClick: () => {},
};

export default SidebarContent;

// region STYLES

const SidebarContentWrap = styled.div`
  height: 100%;
  overflow: auto;
  padding-top: 0;
  
  & > div:last-child {
    width: 4px !important;

    div {
      transition: height 0.3s;
      opacity: 0.52;
    }
  }
  
  @media screen and (min-width: 576px) {
    padding-top: 15px;
    
    ${props => props.collapse && `
      width: 55px;
      overflow: visible !important;
      transition: width 0.3s;
    `}
  }
`;

const SidebarBlock = styled.ul`
  padding: 15px 0;
  border-bottom: 1px solid ${colorBorder};
  list-style-type: none;
  
  &:last-child {
    border: none;
  }
  
  @media screen and (min-width: 576px) {
    
    ${props => props.collapse && `
      & > li > a,
      & > li > button {
        overflow: hidden;
        width: 55px;
        background: ${colorBackground(props)};
        
        span:last-of-type {
          opacity: 0;
          transition: 0.3s;
        }
  
        ${SidebarLinkTitle} {
          position: absolute;
          width: 160px;
          ${left(props)}: 70px;
        }
  
        &:hover {
          background: ${colorHover(props)};
        }
      }
      
      & > li:hover > a,
      & > li:hover > button {
        width: 275px;
        
        span {
          opacity: 1;
        }
      }
    `}
  }
`;

// endregion

